<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 4.53451C0 4.20015 0.167101 3.88792 0.4453 3.70246L5.4453 0.369121C5.7812 0.145189 6.2188 0.145189 6.5547 0.369122L11.5547 3.70246C11.8329 3.88792 12 4.20015 12 4.53451V13.9998C12 14.5521 11.5523 14.9998 11 14.9998H1C0.447715 14.9998 0 14.5521 0 13.9998V4.53451ZM4 10.9993C4 10.447 4.44772 9.99932 5 9.99932H7C7.55228 9.99932 8 10.447 8 10.9993V14.9993H4V10.9993ZM4 6.02422C3.72386 6.02422 3.5 6.24808 3.5 6.52422C3.5 6.80037 3.72386 7.02422 4 7.02422H8C8.27614 7.02422 8.5 6.80037 8.5 6.52422C8.5 6.24808 8.27614 6.02422 8 6.02422H4Z"
    />
  </svg>
</template>
